import { ReactNode } from 'react';

import * as yup from 'yup';
import {
  UnionPay,
  VisaIcon,
  DinersClub,
  DiscoverIcon,
  CreditCardIcon,
  MastercardIcon,
  AmericanExpressIcon,
  CartesBancairesIcon,
  JapanCreditBureauIcon,
} from '../../../../assets/icons';
import i18n from '../../../../i18n';
import { SavedCard } from '../../../../contracts';
import { getCheckoutEmailSchema } from '../../../../utils/checkout-email-validation';

const cardTypeToIconMap: Record<string, ReactNode> = {
  visa: <VisaIcon />,
  unionpay: <UnionPay />,
  diners: <DinersClub />,
  discover: <DiscoverIcon />,
  amex: <AmericanExpressIcon />,
  mastercard: <MastercardIcon />,
  jcb: <JapanCreditBureauIcon />,
  cartesbancaires: <CartesBancairesIcon />,
};

function getSavedCardEmailSchema() {
  return getCheckoutEmailSchema({
    requiredMessage: i18n.t('checkout.fieldErrors.incompleteEmail'),
    invalidMessage: i18n.t('checkout.fieldErrors.invalidEmail'),
  });
}

export function getIconByCardType(cardType: string) {
  const icon = cardTypeToIconMap[cardType?.toLowerCase()];
  return icon || <CreditCardIcon />;
}

export const getSavedCardFormSchema = (
  isSecurityCodeRequired: boolean,
  shouldHideEmailField?: boolean,
) => {
  return yup.object().shape({
    securityCode: isSecurityCodeRequired
      ? yup.string().required(' ').min(3, ' ').max(4, ' ')
      : yup.mixed().nullable(),
    cardID: yup.string().required(''),
    brand: yup.string().notRequired(),
    email: shouldHideEmailField ? yup.string().notRequired() : getSavedCardEmailSchema(),
  });
};

export const savedCardFormSchema = yup.object().shape({
  securityCode: yup.string().required(' ').min(3, ' ').max(4, ' '),
  cardID: yup.string().required(''),
  email: getSavedCardEmailSchema(),
});

export const DIGITS_ONLY_REGEX = /^\d*$/;

export function checkIfCardExpired(
  expMonth: SavedCard['expMonth'],
  expYear: SavedCard['expYear'],
): boolean {
  if (expMonth == null || expYear == null) {
    return false; // support for unionpay cards that don't have exp month and year
  }
  const currentDate = new Date();
  const fullYear = expYear.length === 2 ? `20${expYear}` : expYear;
  const expirationDate = new Date(Number(fullYear), Number(expMonth));

  return currentDate >= expirationDate;
}

export function getFirstCard(cards: SavedCard[]): SavedCard | undefined {
  const validCards = cards.filter((card) => !checkIfCardExpired(card.expMonth, card.expYear));
  return validCards?.[0];
}
